import styled from 'styled-components'
import media from 'styled-media-query'

import { Menu } from '@styled-icons/evaicons-solid/Menu'
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline'

import { Cloud } from '../HeaderSharedComponents/Cloud'

import { customMedia } from '../../../utils/breakpoints'

export const Main = styled.main`
  width: 100%;
  height: 64px;
  left: 0px;
  top: 0px;
  background: ${props => props.theme.header.background};

  display: grid;
  grid-template-columns: 1fr 8fr 2fr;
  grid-template-areas: 'logo menu burguer';
  justify-content:center;

  ${customMedia.lessThan('xs')`
    grid-template-columns: 1fr 6fr 1fr;
    grid-template-areas: 'logo menu burguer';
    justify-content:center;
  `}
  ${customMedia.lessThan('sm')`
    grid-template-columns: 1fr;
  `}

  ${customMedia.greaterThan('lg')`
    max-width: 1366px;
    margin: 0 auto;
    position: relative;
  `}
`

export  const Line = styled.div`
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0px;
  top: 64px;
  background: rgba(22, 22, 22, 0.12);
`

export const ContainerMenuLogo = styled.div`
  position: absolute;
  top: 15px;
  right: 0;
  display: none;

  ${customMedia.lessThan('md')`
    display: block;
  `}
`

export const ContainerMenuLogoClose = styled.div`
  position: absolute;
  top: 15px;
  right: 0;
`

export const ContainerLogoMenuBurger = styled.div`
  position: absolute;
  right: 320px;
`

export const Overlay = styled.div`
  display: ${props => (props.showOverlay ? 'block' : 'none')};
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(22, 22, 22, 0.64);
  z-index: 15;
`

export const LogoMenuBurger = styled(Cloud)`
  width: 35px;
  height: 60px;
  color: ${props => props.theme.header.iconDasa};

  ${media.lessThan('1500px')`
    display: none;
  `}
`

export const MenuText = styled.p`
  color: ${props => props.theme.header.textBurguerButton};
  font-family: ${props => props.theme.font};
  font-size: 14px;
  line-height: 60px;
  text-align: right;
  margin-right: 45px;
  cursor: pointer;
  display: none;

  ${customMedia.lessThan('md')`
    display: block;
  `}

`

export const MenuButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin-right: 10px;
`

export const MenuIcon = styled(Menu)`
  color: ${props => props.theme.header.textBurguerButton};
`

export const MenuCloseIcon = styled(CloseOutline)`
  color: ${props => props.theme.header.textBurguerButton};
`

export const MenuLogo = styled.svg`
  alignment-baseline: central;
`

export const ContainerSearch = styled.div`

`
export const ContainerNavLogo = styled.div`
  display: none;

  ${customMedia.greaterThan('lg')`
    margin-left: auto;
    align-items:center;
    max-width: 140px;
    display: flex;
    justify-content: center;
  `}
`
